import { render, staticRenderFns } from "./pn-and-tf.vue?vue&type=template&id=5911b661"
import script from "./pn-and-tf.vue?vue&type=script&lang=js"
export * from "./pn-and-tf.vue?vue&type=script&lang=js"
import style0 from "./pn-and-tf.vue?vue&type=style&index=0&id=5911b661&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports